import React, { FC, ReactNode } from 'react'

import { IAddedTeamMembers, IRegistrationFees } from '../AddClasses'
import { IEventReviewPublish } from '../../../models/event-review-publish/event-review-publish.interface'
import { IHorseData } from '../../../models/horse/horse.interface'

interface ConfirmDetailsItemProps {
  name: string
  children: ReactNode
}
const ConfirmDetailsItem: FC<ConfirmDetailsItemProps> = ({ name, children }) => {
  return (
    <div className="bg-black/[3%] p-3 flex flex-wrap sm:flex-nowrap items-start justify-between gap-2 rounded-md">
      <div className="w-full sm:w-4/12 text-base">{name}</div>
      <ul className="w-full sm:w-8/12 text-base text-right space-y-2">{children}</ul>
    </div>
  )
}
interface ConfirmDetailsProps {
  publishedEvent: IEventReviewPublish | null
  selectedClasses?: IRegistrationFees[]
  selectedHorses: (IHorseData & { selected?: boolean })[]
  addedTeamMembers: IAddedTeamMembers[]
}

export const ConfirmDetails: FC<ConfirmDetailsProps> = ({
  publishedEvent,
  selectedClasses,
  selectedHorses,
  addedTeamMembers,
}) => {
  return (
    <>
      <h4 className="text-lg font-normal mb-1">Confirm details</h4>
      <p className="text-sm text-black/50 mb-4">Click ‘Add’ to confirm change</p>
      <div className="space-y-2">
        {selectedClasses?.[0] && (
          <ConfirmDetailsItem name="Classes">
            {selectedClasses
              ?.filter((item) => !item.children?.[0])
              .map((item, index) => (
                <li key={index} className="flex items-center justify-end flex-wrap gap-1">
                  {item.name}
                  {item.order ? (
                    <span className="text-xs text-SeabiscuitMainThemeColor bg-SeabiscuitMainThemeColor/5 rounded-full py-0.5 px-3">
                      {item.order}
                    </span>
                  ) : null}
                  {item.qualifyingClass?.price &&
                    publishedEvent?.EventFees?.qualifyingClasses?.isEnable &&
                    item.qualifyingClass?.name &&
                    ` • ${item.qualifyingClass?.name || 'No extra fee'}`}
                </li>
              ))}
          </ConfirmDetailsItem>
        )}
        <ConfirmDetailsItem name="Horse">
          {selectedHorses.map((item, index) => (
            <li key={index} className="flex items-center justify-end flex-wrap gap-1">
              {item.horseName}
            </li>
          ))}
        </ConfirmDetailsItem>
        {addedTeamMembers?.[0] && (
          <ConfirmDetailsItem name="Team">
            {addedTeamMembers.map((item, index) => (
              <li key={index} className="flex items-center justify-end flex-wrap gap-1">
                {item.memberName} • {item.memberRole}
              </li>
            ))}
          </ConfirmDetailsItem>
        )}
      </div>
    </>
  )
}
